import axios from 'axios'

let axiosIns = axios.create({
    baseURL: process.env.VUE_APP_V1
});
axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};

axiosIns.defaults.responseType = 'json';

axiosIns.defaults.validateStatus = (status) => {
    return true;
};
axiosIns.interceptors.request.use((config) => {
    config['timeout'] = 60 * 1000 * 10;

    config['headers']['Authorization'] = localStorage.getItem('token');


    if (config.method === 'get') {
        config.url = config.url.indexOf('?') === -1 ? `${config.url}?_rnd=${Date.now()}` : `${config.url}&_rnd=${Date.now()}`;
    }
    return config;
});

axiosIns.interceptors.response.use((response) => {
    let data = response.data;
    let status = response.status;
    if (data && status === 200) {
        if (data.code === 401) {
            window.$router.replace('/login')
            return Promise.reject(response);
        }
        return Promise.resolve(response);
    } else {
        return Promise.reject(response);
    }
});

let ajaxMethod = ['get', 'post', 'put', 'delete'];
let api = {};
let timeout = {
    timeout: 120000,
};

ajaxMethod.forEach((method) => {
    api[method] = (uri, data, config) => {
        return new Promise(function (resolve, reject) {
            axiosIns[method](uri, data, config).then((response) => {
                if (response.status) {
                    resolve(response);
                } else {
                    resolve(response);
                }
            }).catch((response) => {
                reject(response)
            })
        })
    }
});

let axiosService = (params) => {
    if (params.method === 'get') {
        return new Promise((resolve, reject) => {
            api.get(params.url, { params: params.params }, timeout).then((res) => {
                resolve(res)
            }).catch((e) => reject(e))
        })
    } else if (params.method === 'delete') {
        return new Promise((resolve, reject) => {
            api.delete(params.url, {}, timeout).then((res) => {
                resolve(res)
            }).catch((e) => reject(e))
        })
    } else if (params.method === 'put') {
        return new Promise((resolve, reject) => {
            api.put(params.url, params.data, timeout).then((res) => {
                resolve(res)
            }).catch((e) => reject(e))
        })
    } else {
        return new Promise((resolve, reject) => {
            api.post(params.url, params.data, timeout).then((res) => {
                resolve(res)
            }).catch((e) => reject(e))
        })
    }
};

export default axiosService;

